var isObject=require("./isObject");function isStrictComparable(e){return e==e&&!isObject(e)}module.exports=isStrictComparable;